import { render } from "./edit-lesson.vue?vue&type=template&id=3d6028d4"
import script from "./edit-lesson.vue?vue&type=script&lang=js"
export * from "./edit-lesson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__